

<template>
  <sz-modal v-model="dialog" title="派单" height="700px" width="600px" :showRadio="false">
    <Form style="color: #f2f2f2"  ref="ticketform" :label-width="110" :model="model" :rules="rules">
<Row>
        <i-col :span="24" >
          <FormItem label="日期" style="margin-top: 20px">
            <Input placeholder="请输入日期" v-model="model.field1" />
          </FormItem>
        </i-col>
        <i-col :span="24">
          <FormItem label="接收人" prop="linkman">
            <Input placeholder="请输入接收人" v-model="model.field2" />
          </FormItem>
        </i-col>
        <i-col :span="24">
          <FormItem label="指令类型">
            <Input placeholder="请输入指令类型" v-model="model.field3" />
          </FormItem>
        </i-col>
        <i-col :span="24">
          <FormItem label="业务类型">
            <Input placeholder="请输入业务类型" v-model="model.field4" />
          </FormItem>
        </i-col>
        <i-col :span="24">
          <FormItem label="联系人姓名">
            <Input placeholder="请输入联系人姓名" v-model="model.field5" />
          </FormItem>
        </i-col>
        <i-col :span="24">
          <FormItem label="联系人电话">
            <Input placeholder="请输入联系人电话" v-model="model.field6" />
          </FormItem>
        </i-col>
        <i-col :span="24">
          <FormItem label="工单描述">
            <Input placeholder="请输入工单描述" v-model="model.field7" />
          </FormItem>
        </i-col>
        <i-col :span="24">
          <FormItem label="处理组">
            <Input placeholder="请输入处理组" v-model="model.field8" />
          </FormItem>
        </i-col>
        <i-col :span="24">
          <FormItem label="办理要求">
            <Input placeholder="请输入办理要求" v-model="model.field9" />
          </FormItem>
        </i-col>
      </Row>
    </Form>
    <div style="display: flex;align-items: center;justify-content: center">
      <Button style="width: 100px;margin-right: 20px" @click="dialog = false">取消</Button>
      <Button
          type="primary"
          :loading="formLoading"
          @click="onSubmit"
          style="width: 100px"
      >提交</Button
      >
    </div>
  </sz-modal>
</template>
<script>

import SzModal from "@/components/szModal.vue";
export default {
  components:{SzModal},
  data(){
    return {
      formLoading:false,
      dialog: false,
      model:{},
      rules:{}
    }
  },
  methods:{
    addTicket(row) {
      // this.event = row;
      this.dialog = true;
      this.model = {
        field1:new Date().Format('YYYY/MM/DD'),
        field2:"建设管理部",
        // field3:((row.o_alarm_sensor || {}).o_station||{}).name,
        field3:"水压",
        field4:"水压不足",
        field5:"管理员",
        field6:"87017038",
        // field7:"一般",
        field7:`【${new Date(row.first * 1000).Format(
            "yyyy-MM-dd hh:mm"
        )}】 ${((row.o_alarm_sensor || {}).o_station || {}).name} -> ${
            (row.o_alarm_sensor.o_alarm || {}).name
        }`,
        field8:"",
        field9:"怀疑爆管，及时巡检",
      };
      // this.model.event = row.oid;
      // this.model.address = (row.o_alarm_sensor || {}).o_station.addr;
      // this.model.position = (row.o_alarm_sensor || {}).o_station.position;
      // this.model.desc = `【${new Date(row.first * 1000).Format(
      //     "yyyy-MM-dd"
      // )}】 ${((row.o_alarm_sensor || {}).o_station || {}).name} -> ${
      //     (row.o_alarm_sensor.o_alarm || {}).name
      // }`;
    },
    onSubmit(){
      this.$Message.success("派单成功！");
      this.dialog = false
    },
  }
}
</script>
<style  lang="less">
.ivu-form-item-label{
  color: #f2f2f2 !important;
}
</style>